import { render, staticRenderFns } from "./BonusPayrollPosting.vue?vue&type=template&id=827fb04e&scoped=true"
import script from "./BonusPayrollPosting.vue?vue&type=script&lang=js"
export * from "./BonusPayrollPosting.vue?vue&type=script&lang=js"
import style0 from "./BonusPayrollPosting.vue?vue&type=style&index=0&id=827fb04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827fb04e",
  null
  
)

export default component.exports